var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg100PlusGray(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.73684 0.736841C6.73684 0.329895 6.40695 0 6 0C5.59305 0 5.26316 0.329895 5.26316 0.736841V5.26315H0.736842C0.329895 5.26315 0 5.59304 0 5.99999C0 6.40693 0.329895 6.73683 0.736842 6.73683H5.26316V11.2631C5.26316 11.6701 5.59305 12 6 12C6.40695 12 6.73684 11.6701 6.73684 11.2631V6.73683H11.2632C11.6701 6.73683 12 6.40693 12 5.99999C12 5.59304 11.6701 5.26315 11.2632 5.26315H6.73684V0.736841Z",
    fill: "#474749"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg100PlusGray);
export default __webpack_public_path__ + "static/media/100-plus-gray.530f75fdc1e01e2d50f6aab753a08b74.svg";
export { ForwardRef as ReactComponent };